import React from "react";
import "./apk.scss";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../stores/calculateStore";
import { UiFlagsStore } from "../../stores/uiFlagsStore";
import { Widget } from "../../helpers/widget";
import { RetrieveCalculationService } from "../../services/services/retrieveCalculationService";
import { UserRole } from "../../helpers/userRole";
import EurofinanceFields from "./eurofinance/eurofinanceFields";
import { UserStore } from "../../stores/userStore";
import RenewalContract from "./renewalContract/renewalContract";
import { RequestStatus } from "../../services/services/requestStatus";
import CustomEvents from "../../helpers/CustomEvents";
import EventListenerService from "../../services/services/EventListenerService";
import ApkWebComponent from "./apkWebComponent/apkWebComponent";
import DirectHeader from "./directHeader/directHeader";
import ReactGA from "react-ga4";

interface ApkProps {
  calculateStore?: CalculateStore;
  uiFlagsStore?: UiFlagsStore;
  userStore?: UserStore;
  retrieveCalculationService?: RetrieveCalculationService;
}

@inject("calculateStore", "uiFlagsStore", "retrieveCalculationService", "userStore")
@observer
export default class Apk extends React.Component<ApkProps> {
  private url: URL;

  constructor(props: ApkProps) {
    super(props);
    this.url = new URL(window.location.href);
    this.handleCustomEvent = this.handleCustomEvent.bind(this);

  }

  componentDidMount() {
    this.handleCustomEvent = EventListenerService.addEventListener(
      CustomEvents.ApkNavigateNextPage,
      this.handleCustomEvent
    );
    this.handleGaTag("apkEntry");
  }

  componentWillUnmount() {
    EventListenerService.removeEventListener(
      CustomEvents.ApkNavigateNextPage,
      this.handleCustomEvent
    );
  }

  render() {
    return (
      <div className="content apk">
        {!this.props.uiFlagsStore!.isDirect && (
          <RenewalContract />
        )}
        {this.props.uiFlagsStore!.isDirect && (
          <DirectHeader />
        )}

        {UserRole.isEurofinanceRole(this.props.userStore!.roles) && (
          <EurofinanceFields />
        )}

        {
          <ApkWebComponent
            uiFlagsStore={this.props.uiFlagsStore}
            calculationstore={this.props.calculateStore}
          />
        }
      </div>
    );
  }

  private goToNextStep() {
    Widget.goToNextStep(this.props.uiFlagsStore!);
  }

  private resetStoreDependsOnApk() {
    const retrieveCalculationRequestStatus = this.props.retrieveCalculationService!.retrieveCalculationRequestStatus;
    const retrieveContractBySeriesAndNumberRequestStatus = this.props.retrieveCalculationService!.retrieveContractForRenewalBySeriesAndNumberRequestStatus;
    const retrieveContractByIdRequestStatus = this.props.retrieveCalculationService!.retrieveContractForRenewalByIdRequestStatus;

    if (this.requestFailedOrNotExecute(retrieveCalculationRequestStatus) &&
      this.requestFailedOrNotExecute(retrieveContractBySeriesAndNumberRequestStatus) &&
      this.requestFailedOrNotExecute(retrieveContractByIdRequestStatus)) {
      this.props.calculateStore!.resetDiscountsAndAdditionalClauses();
    }

    if (!this.props.calculateStore!.isFlat) {
      this.props.calculateStore!.resetFloor();
    }



    if (!this.props.calculateStore!.externalApk && !this.props.calculateStore?.propertyInsuranceApk && !this.props.calculateStore!.externalApkNoAndClientConsentNo) {
      this.props.calculateStore!.resetPackages();
      this.props.calculateStore!.resetSelectPackage();
      if (this.props.calculateStore!.nnw || this.props.calculateStore?.oc) {
        this.props.calculateStore!.resetAdditionalProtections();
        this.props.calculateStore!.resetPropertyAdditionalQuestion();
        if (this.props.calculateStore!.nnw && this.props.calculateStore?.oc) {
          this.props.calculateStore!.resetAdditionalInsurancesWithoutNnwAndOc();
        } else if (this.props.calculateStore!.nnw) {
          this.props.calculateStore!.resetEstate();
          this.props.calculateStore!.resetAdditionalInsurancesWithoutNnw();
        } else if (this.props.calculateStore!.oc) {
          this.props.calculateStore!.resetAdditionalInsurancesWithoutOc();
        }
      }
    }
  }

  private requestFailedOrNotExecute(requestStatus: RequestStatus) {
    return !requestStatus.isDone || requestStatus.isError;
  }

  handleCustomEvent(data: any) {
    const tuzApkManager = document.querySelector(
      'tuz-apk-manager',
    ) as HTMLElement;
    if (tuzApkManager) {
      tuzApkManager.style.display = 'none';
    }

    this.props.calculateStore!.setApkUsingNewModel(
      data.apkUuid,
      data.answers,
      this.props.uiFlagsStore!.isDirect,
    );
    this.resetStoreDependsOnApk();
    this.props.calculateStore!.setApkToAdditionalQuestions();
    this.props.calculateStore!.refreshCalcultionRequire();
    this.props.calculateStore!.setPropertyInsurancesOcNnw();

    if (this.props.calculateStore!.propertyInsuranceOrOcChecked) {
      this.goToNextStep();
    } else if (this.props.calculateStore!.externalApkNoAndClientConsentNo) {
      this.props.calculateStore?.setPropertyInsurance(true, true);
      this.goToNextStep();
    }
    else {
      this.props.uiFlagsStore!.goToOfferCustomizerStep();
    }
  }
  private handleGaTag(action:string) {
    if (this.props.uiFlagsStore?.isDirect) {
      ReactGA.event({category: "event", action: `${action}`});
    }
  }
}
